(() => {
  function setupProduct() {
    document.querySelectorAll('.mh-description-body h2,.mh-description-body h3').forEach(heading => {
      if (!/^(Maße|Abmessungen|Material)$/i.test(heading.textContent.trim())) return;
      const list = heading.nextElementSibling;
      if (!list || list.tagName !== 'UL') return;
      const items = [...list.children];
      if (!items.length || items.some(li => !li.textContent.includes(':') || li.children.length)) return;
      const table = document.createElement('table');
      table.className = 'mh-spec-table';
      const caption = document.createElement('caption'); caption.className = 'visually-hidden'; caption.textContent = heading.textContent; table.append(caption);
      const tbody = document.createElement('tbody');
      items.forEach(li => {
        const text = li.textContent, at = text.indexOf(':');
        const row = document.createElement('tr'), key = document.createElement('th'), value = document.createElement('td');
        key.scope = 'row'; key.textContent = text.slice(0,at).trim(); value.textContent = text.slice(at+1).trim(); row.append(key,value); tbody.append(row);
      });
      table.append(tbody); list.replaceWith(table);
    });
    const info = document.querySelector('product-info[id^="MainProduct"]');
    if (!info || document.querySelector('.mh-sticky-buy')) return;
    const original = info.querySelector('button[name="add"]');
    if (!original) return;
    const bar = document.createElement('div');
    bar.className = 'mh-sticky-buy'; bar.hidden = true;
    bar.setAttribute('aria-label', 'Ausgewählter Artikel');
    bar.innerHTML = '<div><strong></strong><small>inkl. MwSt. · Versand in DE frei</small></div><button class="button" type="button">In den Warenkorb</button>';
    document.body.append(bar);
    let visible = true;
    function sync() {
      const price = info.querySelector('.price--on-sale .price-item--sale') || info.querySelector('[id^="price-"] .price-item--regular');
      const source = info.querySelector('button[name="add"]');
      if (!source) { bar.hidden = true; return; }
      bar.querySelector('strong').textContent = price?.textContent.trim() || '';
      const disabled = source.disabled || source.getAttribute('aria-disabled') === 'true';
      bar.querySelector('button').disabled = disabled;
      bar.querySelector('button').textContent = disabled ? source.textContent.trim() : 'In den Warenkorb';
      const rect = source.getBoundingClientRect();
      bar.hidden = !price || (rect.top < window.innerHeight && rect.bottom > 0);
      document.body.classList.toggle('mh-has-buy-bar', !bar.hidden);
      const variants = info.querySelector('[data-mh-variants]');
      const id = info.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')?.value;
      const variant = variants && JSON.parse(variants.textContent).find(v => String(v.id) === id);
      let label = bar.querySelector('.mh-buy-variant');
      if (!label) { label = document.createElement('small'); label.className = 'mh-buy-variant'; bar.firstElementChild.prepend(label); }
      label.textContent = variant && variant.title !== 'Default Title' ? variant.title : '';
    }
    new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, {threshold:0}).observe(original);
    new MutationObserver(sync).observe(info,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled','class']});
    bar.querySelector('button').addEventListener('click', () => {
      const source = info.querySelector('button[name="add"]');
      if (source && !source.disabled) source.click();
    });
    window.addEventListener('scroll', sync, {passive:true});
    window.addEventListener('resize', sync);
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupProduct); else setupProduct();
  document.addEventListener('shopify:section:load', setupProduct);
})();
